import type { UseToastOptions } from "@chakra-ui/react";

type ToastFunction = (options?: UseToastOptions) => void;

let toastFn: ToastFunction | null = null;

export const initToast = (toast: ToastFunction) => {
  toastFn = toast;
};

export const showToast = (options: {
  description?: string;
  status?: "success" | "error" | "warning" | "info";
  duration?: number;
  isClosable?: boolean;
  position?: UseToastOptions["position"];
  title?: string;
}) => {
  if (toastFn) {
    toastFn({
      duration: 5000,
      isClosable: true,
      position: "top-left",
      ...options,
    });
  } else {
    console.warn("Toast not initialized. Call initToast() first.");
  }
};
